angular.module('bb.appointments.feedback', []);

require('./feedback.service');

require('./feedback_settings.component');
require('./question_customizer.component');
require('./form_builder.component');
require('./question_sortable.component');
require('./question_edit_modal.component');
require('./feedback_agent_notifications.component');
require('./feedback_list.component');
require('./feedback_view.component');

require('./feedback.routes');
